export const _SET_PHONE_NUMBER_VALUE = "setPhoneNumberValue"

export default {
  [_SET_PHONE_NUMBER_VALUE](state, phoneNumberValue: PhoneNumberPair) {
    state.phoneNumberValue = phoneNumberValue
  }
}
